import React from 'react';

import styled from 'styled-components';

import { Icon, Tag, theme } from 'components';

interface AddElementProps {
  label: string;
  onClick: () => void;
}

const AddElement: React.FC<AddElementProps> = ({ onClick, label }) => (
  <Container>
    <StyledTag
      // @ts-ignore
      icon={
        <Icon
          type="plus"
          color="gray8"
          height={16}
          width={16}
          offset={[0, 1.25]}
        />
      }
      color={theme.gray8}
      onClick={onClick}
      style={{ fontWeight: 600, fontSize: 14 }}
      data-cy={`add-tag-styled-${label.split(' ').join('-')}`}
    >
      {label}
    </StyledTag>
  </Container>
);

const Container = styled.div``;

const StyledTag = styled(Tag)`
  cursor: pointer;
  background-color: ${theme.white};
  color: ${theme.gray8};
`;

export default AddElement;
